module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-content block-content-full border-bottom"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col py-5"
  }, [_c('h3', {
    staticClass: "h5 font-w700 mb-10"
  }, [(_vm.job.status === 'queued') ? _c('i', {
    class: "fa fa-hourglass-o text-warning mr-5"
  }) : (_vm.job.status === 'finished') ? _c('i', {
    class: "fa fa-check text-success mr-5"
  }) : (_vm.job.status === 'failed') ? _c('i', {
    class: "fa fa-times text-danger mr-5"
  }) : (_vm.job.status === 'executing') ? _c('i', {
    class: "fa fa-spinner fa-spin text-info mr-5"
  }) : _vm._e(), _vm._v("\n\n        " + _vm._s(_vm.name)), (_vm.job.status === 'executing') ? _c('span', [_vm._v("...")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "progress mb-5",
    staticStyle: {
      "height": "8px"
    }
  }, [(_vm.job.status === 'queued') ? _c('div', {
    staticClass: "progress-bar",
    style: ({
      width: '0%'
    }),
    attrs: {
      "role": "progressbar"
    }
  }) : (_vm.job.status === 'finished') ? _c('div', {
    staticClass: "progress-bar bg-success",
    style: ({
      width: '100%'
    }),
    attrs: {
      "role": "progressbar"
    }
  }) : (_vm.job.status === 'failed') ? _c('div', {
    staticClass: "progress-bar bg-danger",
    style: ({
      width: (_vm.progress + "%")
    }),
    attrs: {
      "role": "progressbar"
    }
  }) : (_vm.job.status === 'executing') ? _c('div', {
    staticClass: "progress-bar progress-bar-striped progress-bar-animated bg-info",
    style: ({
      width: (_vm.progress + "%")
    }),
    attrs: {
      "role": "progressbar"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.job.status === 'queued') ? _c('p', {
    staticClass: "font-size-sm font-w600 mb-0"
  }, [_vm._v("In de wachtrij...")]) : (_vm.job.status === 'executing') ? _c('p', {
    staticClass: "font-size-sm font-w600 mb-0"
  }, [(_vm.job.progress_max) ? _c('span', [_c('span', {
    staticClass: "font-w700"
  }, [_vm._v(_vm._s(_vm.job.progress_now))]), _vm._v(" van "), _c('span', {
    staticClass: "font-w700"
  }, [_vm._v(_vm._s(_vm.job.progress_max))])]) : _c('span', [_vm._v("Bezig...")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b058b02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/jobs/JobListItem.vue
// module id = 741
// module chunks = 1